import { render, staticRenderFns } from "./OptDocumentDialog.vue?vue&type=template&id=ec3aa97a&scoped=true"
import script from "./OptDocumentDialog.vue?vue&type=script&lang=js"
export * from "./OptDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./OptDocumentDialog.vue?vue&type=style&index=0&id=ec3aa97a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3aa97a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec3aa97a')) {
      api.createRecord('ec3aa97a', component.options)
    } else {
      api.reload('ec3aa97a', component.options)
    }
    module.hot.accept("./OptDocumentDialog.vue?vue&type=template&id=ec3aa97a&scoped=true", function () {
      api.rerender('ec3aa97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/components/OptDocumentDialog.vue"
export default component.exports